module.exports = __webpack_public_path__ + "static/media/notification.5af5f071.svg";